import React from "react";
import { Box } from "rebass/styled-components";
import { ReactComponent as AllstarLogo } from "../../../assets/images/logo/aMark.svg";

export default function AMark(props) {
  return <Box as={AllstarLogo} fill="currentColor" {...props} />;
}
